export const MESSAGE_TYPE = {
  INBOX: "INBOX",
  SENT: "SENT",
  ARCHIVED: "ARCHIVED",
  ALL: "ALL",
};
